module.exports = "<div class=\"row\" id=\"row-content-contact\">\r\n    <div class=\"col-12 p-0\">\r\n        <div class=\" pt-5 home-page\" id=\"collections-container-contact\">\r\n        \r\n        </div>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/contact/contact.component.html
// module id = ./src/app/contact/contact.component.html
// module chunks = main